import { Component, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'lp-statistics-button',
  templateUrl: './statistics-button.component.html',
  styleUrls: ['./statistics-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatisticsButtonComponent extends BaseResizableComponent {
  @Output() buttonClick = new EventEmitter();
}
